module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-plus-9d6d933a.svg";